import { render, staticRenderFns } from "./RoomDamagesList.vue?vue&type=template&id=9c8f3e9a&scoped=true"
import script from "./RoomDamagesList.vue?vue&type=script&lang=ts"
export * from "./RoomDamagesList.vue?vue&type=script&lang=ts"
import style0 from "./RoomDamagesList.vue?vue&type=style&index=0&id=9c8f3e9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c8f3e9a",
  null
  
)

export default component.exports